import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialTextInputArea1: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 11.435H32v9.14h-1.52Zm-12.19-1.53h12.19v1.53H18.29Zm0 10.67h12.19v1.52H18.29Zm-1.53-13.72h3.05v1.53h-3.05Zm0 16.77h3.05v1.52h-3.05Zm-1.52-15.24h1.52v15.24h-1.52Zm-3.05-1.53h3.05v1.53h-3.05Zm0 16.77h3.05v1.52h-3.05Zm-10.66-3.05h12.19v1.52H1.53Zm6.09-1.53v-1.52h1.53v-1.52h1.52v-1.53H9.15v-1.52H7.62v1.52H6.1v-1.52H4.57v1.52H3.05v1.53h1.52v1.52H6.1v1.52zm-6.09-9.14h12.19v1.53H1.53ZM0 11.435h1.53v9.14H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialTextInputArea1
